export const baseUri = process.env.VUE_APP_BASE_URI || `http://localhost:8000/api/`
export const edgeUri = process.env.VUE_APP_REST_EDGE_HOST || `http://localhost:3003/`
export const measurementUri = process.env.VUE_APP_MEASUREMENT_URI || `http://localhost:8010/`
export const accessToken = process.env.VUE_APP_TOKEN
export const defaultSavedConfig = process.env.VUE_APP_DEFAULT_SAVED
export const backendUrl = process.env.VUE_APP_API_HOST
export const sshrDomain = process.env.VUE_APP_SSHR_DOMAIN
export const googleMapKey = process.env.VUE_APP_GOOGLE_MAP_KEY
export const viewPrice = process.env.VUE_APP_SHOW_PRICE
export const adxToken = process.env.VUE_APP_AUTH_TOKEN
export const midtransConfig = {
  key: process.env.VUE_APP_MIDTRANS_KEY,
  lib: process.env.VUE_APP_MIDTRANS_LIB
}

export const v2 = `v2`
export const api = `api`

const config = {
  baseUri,
  edgeUri,
  measurementUri,
  accessToken,
  defaultSavedConfig,
  backendUrl,
  midtransConfig,
  v2,
  api,
  sshrDomain,
  googleMapKey,
  adxToken
}
export default config
